import { createStore, createEvent } from "effector";
import HTTP from "../core/http";

export type Outcome = {
	id: number,
	name: string
}
export type Competitor = {
	logo_base64: string,
	name: string
}
export type Event = {
	competitors: Competitor[],
	date: number,
	id: number,
	name: string,
	outcome_win: string|null,
	outcomes: Outcome[]
}

export type NewCheckElement = {
	index: number,
	id: number
}
export type CheckElement = {
	[name:string]: {
		id: number,
	}
}

export type App = {
	appIsMobile: boolean,
	isSmallScreen: boolean,

	checked: CheckElement,

	accepted_date: number,
	can_accepted: boolean,
	dict: any,
	event: Event[],
	is_bet: number,
	name: string,
	prediction_user: any[],
	sport_url: string,
	user_authorization: boolean
}


const mock = {
	appIsMobile: false,
	isSmallScreen: false,

	checked: {},

	accepted_date: -1,
	can_accepted: false,
	dict: {},
	event: [],
	is_bet: 0,
	name: "",
	prediction_user: [],
	sport_url: "",
	user_authorization: false
}

export const confirmPredictions = createEvent();
export const setAppIsMobile = createEvent<boolean>();
export const setIsSmallScreen = createEvent<boolean>();
export const initEvents = createEvent<App>();
export const setChecked = createEvent<NewCheckElement>();
export const clear = createEvent();

export const $app = createStore<App>(mock)
	.on(confirmPredictions, (state) => {
		const newArr = [];
		for (const el in state.checked) {
			newArr.push(state.checked[el].id)
		}
		if(newArr.length===4) HTTP.confirmPredictions(newArr);
	})
	.on(setAppIsMobile, (state, appIsMobile:boolean) => { return {...state, appIsMobile}; })
	.on(setIsSmallScreen, (state, isSmallScreen:boolean) => { return {...state, isSmallScreen}; })
	.on(initEvents, (state, newState:App) => { return {...state, ...newState}; })
	.on(setChecked, (state, el) => {
		state.checked[el.index] = { id: el.id };
		return {...state, checked: state.checked };
	})
	.reset(clear);
